export const getStyled = (theme) => ({
  container: {
    textAlign: 'center',
    marginTop: theme.spacing(8),
    flex: 1,
  },
  title: {
    marginBottom: theme.spacing(4),
  },
  button: {
    marginTop: theme.spacing(2),
    color: '#fff !important',
    boxShadow: 'none',
    borderRadius: 20,
  },
  boxContainer: {
    background: theme.palette.tabHeaderBackground,
    borderRadius: 20,
    display: 'flex',
    padding: 20,
    alignItems: 'center',
    width: '80%',
    justifyContent: 'center',
    margin: 'auto',
  },
});
